import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box } from "@ui/box/Box";
import { Page } from "@ui/page/Page";
import { GD } from "../../GD";
import { Banknote } from "lucide-react";

export const PayoutsPage = () => {
	useLocale();
	//const [req] = GD.B_USERS.use({ ts: +new Date() });
	const [project] = GD.REQ_CURRENT_PROJECT.useRequest();

	const label = project && project?.name + msg("payouts_869aa972");

	// const onAdd = async () => {
	// 	S_ADD_CLIENT_POPUP.invoke({
	// 		clientID: 0,
	// 	});
	// };

	return (
		<Page
			label={label ?? undefined}
			description={msg("payoutOperationsBalancesReservesAndOutgoingSettlements")}
			icon={<Banknote size={20} />}
			rightSection={<RightSectionPayouts />}
			// sectionRightContent={
			// 	<>
			// 		<Button onClick={onAdd} title="Add Client" variant="primarySmall" />
			// 	</>
			// }
			>
			{/* <Error error={req?.error} />
			{req?.error && <Spacer size="20px" />}

			{req && !req.error && (
				<Table<IUser>
					// onRowClick={row => userSelected(row.uid)}
					data={req.data ?? []}
				/>
			)} */}
		</Page>
	);
};

const RightSectionPayouts = () => {
	useLocale();
	return (
		<Box
			sx={{
				display: "flex",
				flex: 1,
				minHeight: "0px",
				flexDirection: "column",

				gap: "10px",
			}}>
			{/* <Comments sectionType={0} targetId={1} targetType="client" />
			<EventsClients target_id={1} target_type="client" /> */}
		</Box>
	);
};
